const TOKEN_KEY = 'token_wl';
const HANDSHAKE_SUPPORT_KEY = 'channel_api_token_handshake';
const TOKEN_UPDATED_EVENT = 'channel-api-token-updated';

let pendingTokenRequest = null;

export function getParentOrigin() {
    if (typeof document === 'undefined' || !document.referrer) return null;

    try {
        return new URL(document.referrer).origin;
    } catch {
        return null;
    }
}

export function isTrustedParentMessage(event) {
    const parentOrigin = getParentOrigin();

    return Boolean(
        parentOrigin &&
        event?.source === window.parent &&
        event?.origin === parentOrigin
    );
}

export function postToParent(message) {
    const parentOrigin = getParentOrigin();

    if (!parentOrigin || window.parent === window) return false;

    window.parent.postMessage(message, parentOrigin);
    return true;
}

export function setChannelApiToken(token) {
    if (typeof token !== 'string' || !token.trim()) return false;

    localStorage.setItem(TOKEN_KEY, token);
    sessionStorage.setItem(HANDSHAKE_SUPPORT_KEY, 'true');
    window.dispatchEvent(new Event(TOKEN_UPDATED_EVENT));
    return true;
}

export function markChannelApiTokenUnsupported() {
    localStorage.removeItem(TOKEN_KEY);
    sessionStorage.setItem(HANDSHAKE_SUPPORT_KEY, 'false');
}

export function requestChannelApiToken(timeoutMs = 5000) {
    if (sessionStorage.getItem(HANDSHAKE_SUPPORT_KEY) === 'false') {
        return Promise.reject(new Error('A loja ainda não suporta token de API pelo handshake.'));
    }

    if (pendingTokenRequest) return pendingTokenRequest;

    pendingTokenRequest = new Promise((resolve, reject) => {
        let timeoutId;

        const cleanup = () => {
            window.removeEventListener(TOKEN_UPDATED_EVENT, handleTokenUpdated);
            if (timeoutId) clearTimeout(timeoutId);
        };

        const handleTokenUpdated = () => {
            const token = localStorage.getItem(TOKEN_KEY);
            cleanup();

            if (token) {
                resolve(token);
            } else {
                reject(new Error('A loja respondeu sem token de API.'));
            }
        };

        window.addEventListener(TOKEN_UPDATED_EVENT, handleTokenUpdated);

        timeoutId = setTimeout(() => {
            cleanup();
            reject(new Error('Tempo esgotado ao solicitar token de API para a loja.'));
        }, timeoutMs);

        if (!postToParent({ type: 'API_TOKEN_REQUEST' })) {
            cleanup();
            reject(new Error('Não foi possível solicitar token de API para a loja.'));
        }
    }).finally(() => {
        pendingTokenRequest = null;
    });

    return pendingTokenRequest;
}
